import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";
import { components } from "react-select";
import { SingleValueProps } from "react-select/src/components/SingleValue";

import { SELECT_CLASS_NAME } from "../types";

export const SingleValue: FunctionComponent<SingleValueProps<any>> = memo(props => {
  const size = props.selectProps.size;
  const classes = classNames(props.className, {
    [`${SELECT_CLASS_NAME}__single-value--size-${size}`]: size,
  });
  return <components.SingleValue {...props} className={classes} />;
});
